import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDMdAodQe8UKJ3sgwMkfg8NNzVEuLBey2U",
//   authDomain: "modern-tribe-f1e3f.firebaseapp.com",
//   projectId: "modern-tribe-f1e3f",
//   storageBucket: "modern-tribe-f1e3f.firebasestorage.app",
//   messagingSenderId: "866790556383",
//   appId: "1:866790556383:web:a4ca13b13ae3c8c6f7df6a",
//   measurementId: "G-M9RH1NF4FG",
// };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
